import { JobExpandablePropertyType } from '@/enum'
import { ItemTypeExpression } from '@/enum/LinqExpressionType'

const updateResponseExpandableResources = [
  JobExpandablePropertyType.SCHEDULE,
  JobExpandablePropertyType.ASSIGNED_EMPLOYEES,
  JobExpandablePropertyType.ASSIGNED_EMPLOYEES_EMPLOYEE,
  JobExpandablePropertyType.TASK_SHEETS,
  JobExpandablePropertyType.TASK_SHEETS_HEADER,
  JobExpandablePropertyType.TASK_SHEETS_BODIES,
  JobExpandablePropertyType.TASK_SHEETS_FOOTER,
  JobExpandablePropertyType.WORK_ORDER_VENDOR,
  JobExpandablePropertyType.ASSET,
  JobExpandablePropertyType.ASSET_INFO,
  JobExpandablePropertyType.ASSET_EQUIPMENT,
  JobExpandablePropertyType.ASSET_MACHINE,
  JobExpandablePropertyType.ASSET_VEHICLE,
  JobExpandablePropertyType.ISSUE_REPORTER,
  JobExpandablePropertyType.DOCUMENTS,
  JobExpandablePropertyType.MAINTENANCE_TYPES
]

export const expandedProperties = {
  [ItemTypeExpression.Expand]: updateResponseExpandableResources.join(',')
}
